import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const [needsOnboarding, setNeedsOnboarding] = useState(null); // null=loading, true/false

  useEffect(() => {
    if (!user || user.role !== "employee") { setNeedsOnboarding(false); return; }
    api.get("/me/profile").then(({ data }) => {
      setNeedsOnboarding(!data.employee?.onboarded_at);
    }).catch(() => setNeedsOnboarding(false));
  }, [user]);

  if (loading || (user && user.role === "employee" && needsOnboarding === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500" data-testid="auth-loading">
        <div className="animate-pulse text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  if (needsOnboarding && loc.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return children;
}
